import { Button, Dialog, Text } from '@betterment/samba-react';

import { ForecasterProjectionDisclosuresFragment } from '../graphql/forecasterProjectionDisclosures.generated';

type Props = {
  disclosures: ForecasterProjectionDisclosuresFragment;
};

export const ProjectionDisclosures = ({ disclosures }: Props) => {
  return (
    <Text as="span" variant="text25" color="text.weak">
      {disclosures.projectionReturnsDisclosure}{' '}
      <Dialog overlay="default">
        <Dialog.Trigger asChild={true}>
          <Button variant="textPrimary" css={{ textStyle: 'text.50', color: 'text.weak', textDecoration: 'underline' }}>
            Learn more
          </Button>
        </Dialog.Trigger>
        <Dialog.Content
          css={{
            padding: 'space.400',
            width: '90vw',
            maxWidth: 'container.xlarge',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <Text
            color="text.critical"
            css={{
              '& p': {
                textStyle: 'text50',
                color: 'text.weak',
              },
              '& h4': {
                textStyle: 'title100',
                color: 'text',
              },
            }}
            dangerouslySetInnerHTML={{ __html: disclosures.projectionReturnsAssumptionsDisclosure }}
          />
        </Dialog.Content>
      </Dialog>
    </Text>
  );
};
